module.exports = __webpack_public_path__ + "static/media/city.c96cc742.png";